import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import moment from 'moment';
import { Employee, EmployeePositionId } from '../../../models/employee/Employee';
import { EmployeeRoleAdapter } from './EmployeeRoleAdapter.service';
import { EmployeeSummaryResponse } from '../../../../interfaces/response/EmployeeResponse';

/**
 * An adapter converts employee HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class EmployeeAdapter implements Adapter<Employee> {

  /**
   * Converts employee HTTP response to {@link Employee}.
   * @param item employee HTTP response.
   */
  adapt(item: EmployeeSummaryResponse): Employee {
    const employeeRoleAdapter = new EmployeeRoleAdapter();
    return new Employee(
      new EmployeePositionId(item.employeeId, item.positionId),
      item.name,
      employeeRoleAdapter.adapt(item.role),
      moment.duration(item.contractHours).asHours(),
      item.availableFrom,
      item.deletedFrom
    );
  }
}
